var _path, _path2, _circle, _circle2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWrapUnwrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 7.8376C13.7945 7.56168 13.7945 7.11434 13.5186 6.83843C13.2427 6.56251 12.7953 6.56251 12.5194 6.83843L13.5186 7.8376ZM10.3554 10.0016L9.85579 9.50206C9.57988 9.77798 9.57988 10.2253 9.85579 10.5012L10.3554 10.0016ZM12.5194 13.1649C12.7953 13.4408 13.2427 13.4408 13.5186 13.1649C13.7945 12.889 13.7945 12.4416 13.5186 12.1657L12.5194 13.1649ZM12.5194 6.83843L9.85579 9.50206L10.855 10.5012L13.5186 7.8376L12.5194 6.83843ZM9.85579 10.5012L12.5194 13.1649L13.5186 12.1657L10.855 9.50206L9.85579 10.5012Z",
    fill: "url(#paint0_linear_175_265)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78602 6.92854C10.0619 6.65263 10.0619 6.20528 9.78602 5.92937C9.51011 5.65346 9.06277 5.65346 8.78685 5.92937L9.78602 6.92854ZM5.71501 10.0004L5.21543 9.5008C4.93951 9.77671 4.93951 10.2241 5.21543 10.5L5.71501 10.0004ZM8.78685 14.0714C9.06277 14.3473 9.51011 14.3473 9.78602 14.0714C10.0619 13.7955 10.0619 13.3481 9.78602 13.0722L8.78685 14.0714ZM8.78685 5.92937L5.21543 9.5008L6.2146 10.5L9.78602 6.92854L8.78685 5.92937ZM5.21543 10.5L8.78685 14.0714L9.78602 13.0722L6.2146 9.5008L5.21543 10.5Z",
    fill: "url(#paint1_linear_175_265)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99999,
    cy: 9.99999,
    r: 9.29347,
    stroke: "url(#paint2_linear_175_265)",
    strokeWidth: 1.41304
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5887,
    cy: 10,
    r: 9.31796,
    transform: "rotate(-180 21.5887 10)",
    fill: "#3A3737",
    stroke: "url(#paint3_linear_175_265)",
    strokeWidth: 1.36406
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0864 12.1797C17.8201 12.4461 17.8201 12.8779 18.0864 13.1443C18.3528 13.4106 18.7846 13.4106 19.051 13.1443L18.0864 12.1797ZM21.2323 9.99835L21.7146 10.4806C21.981 10.2143 21.981 9.78243 21.7146 9.51608L21.2323 9.99835ZM19.051 6.85245C18.7846 6.5861 18.3528 6.5861 18.0864 6.85245C17.8201 7.1188 17.8201 7.55064 18.0864 7.81699L19.051 6.85245ZM19.051 13.1443L21.7146 10.4806L20.7501 9.51608L18.0864 12.1797L19.051 13.1443ZM21.7146 9.51608L19.051 6.85245L18.0864 7.81699L20.7501 10.4806L21.7146 9.51608Z",
    fill: "url(#paint4_linear_175_265)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8197 13.0888C21.5534 13.3551 21.5534 13.787 21.8197 14.0533C22.0861 14.3197 22.5179 14.3197 22.7842 14.0533L21.8197 13.0888ZM25.8734 9.99962L26.3557 10.4819C26.622 10.2155 26.622 9.7837 26.3557 9.51735L25.8734 9.99962ZM22.7842 5.94592C22.5179 5.67957 22.0861 5.67957 21.8197 5.94592C21.5534 6.21227 21.5534 6.64411 21.8197 6.91046L22.7842 5.94592ZM22.7842 14.0533L26.3557 10.4819L25.3911 9.51735L21.8197 13.0888L22.7842 14.0533ZM26.3557 9.51735L22.7842 5.94592L21.8197 6.91046L25.3911 10.4819L26.3557 9.51735Z",
    fill: "url(#paint5_linear_175_265)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_265",
    x1: 13.019,
    y1: 12.6653,
    x2: 8.90574,
    y2: 8.9376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_175_265",
    x1: 9.28644,
    y1: 13.5718,
    x2: 3.77132,
    y2: 8.5737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_175_265",
    x1: 20,
    y1: 0,
    x2: -3.79218,
    y2: 13.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_175_265",
    x1: 31.5887,
    y1: 0.0000104904,
    x2: 7.79649,
    y2: 13.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_175_265",
    x1: 18.5687,
    y1: 7.33472,
    x2: 22.682,
    y2: 11.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_175_265",
    x1: 22.302,
    y1: 6.42819,
    x2: 27.8171,
    y2: 11.4263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrapUnwrap);
export default __webpack_public_path__ + "static/media/icon_wrap_unwrap.160a344f2140ddcd4f8f9c5baac87bc5.svg";
export { ForwardRef as ReactComponent };